const conselhos = [
  {
    value: '01',
    text: 'CRAS Conselho Regional de Assistência Social - SP/SADT 3.05.00',
    tabela: '01'
  },
  {
    value: '02',
    text: 'COREN Conselho Regional de Enfermagem - SNGPC - SP/SADT 3.05.00/4.01.00',
    tabela: '02'
  },
  {
    value: '03',
    text: 'CRF Conselho Regional de Farmácia - SNGPC  - SP/SADT 3.05.00/4.01.00',
    tabela: '03'
  },
  {
    value: '04',
    text: 'CRFA Conselho Regional de Fonoaudiologia  - SP/SADT 3.05.00',
    tabela: '04'
  },
  {
    value: '05',
    text: 'CREFITO Conselho Regional de Fisioterapia e Terapia Ocupacional - SP/SADT 3.05.00/4.01.00',
    tabela: '05'
  },
  {
    value: '06',
    text: 'CRM Conselho Regional de Medicina - SNGPC - SP/SADT 3.05.00/4.01.00',
    tabela: '06'
  },
  {
    value: '07',
    text: 'CRN Conselho Regional de Nutrição - SP/SADT 3.05.00/4.01.00',
    tabela: '07'
  },
  {
    value: '08',
    text: 'CRO Conselho Regional de Odontologia - SNGPC - SP/SADT 3.05.00/4.01.00',
    tabela: '08'
  },
  {
    value: '09',
    text: 'CRP Conselho Regional de Psicologia - SP/SADT 3.05.00/4.01.00',
    tabela: '09'
  },
  {
    value: '11',
    text: 'RMS - Registro Ministério da Saúde - SNGPC',
    tabela: ''
  },
  {
    value: '10',
    text: 'OUT Outros Conselhos - SP/SADT 3.05.00/4.01.00',
    tabela: '10'
  },
  {
    value: '12',
    text: 'CRESS Conselho Regional de Serviço Social - SP/SADT 4.01.00',
    tabela: '01'
  },
  {
    value: '12',
    text: 'CREFONO Conselho Regional de Fonoaudiologia - SP/SADT 4.01.00',
    tabela: '04'
  },
  {
    value: '13',
    text: 'CRBio Conselho Regional de Biologia - SP/SADT 4.01.00',
    tabela: '11'
  },
  {
    value: '14',
    text: 'CRBM Conselho Regional de Biomedicina - SP/SADT 4.01.00',
    tabela: '12'
  },
  {
    value: '15',
    text: 'CREF Conselho Regional de Educação Física - SP/SADT 4.01.00',
    tabela: '13'
  },
  {
    value: '16',
    text: 'CRMV Conselho Regional de Medicina Veterinária - SP/SADT 4.01.00',
    tabela: '14'
  },
  {
    value: '17',
    text: 'CRTR Conselho Regional de Técnicos em Radiologia - SP/SADT 4.01.00',
    tabela: '15'
  }
];

const ufs = [
  {
    value: '12',
    text: 'AC - Acre'
  },
  {
    value: '27',
    text: 'AL - Alagoas'
  },
  {
    value: '16',
    text: 'AP - Amapá'
  },
  {
    value: '13',
    text: 'AM - Amazonas'
  },
  {
    value: '29',
    text: 'BA - Bahia'
  },
  {
    value: '23',
    text: 'CE - Ceará'
  },
  {
    value: '53',
    text: 'DF - Distrito Federal'
  },
  {
    value: '32',
    text: 'ES - Espírito Santo'
  },
  {
    value: '52',
    text: 'GO - Goiás'
  },
  {
    value: '21',
    text: 'MA - Maranhão'
  },
  {
    value: '50',
    text: 'MS - Mato Grosso do Sul'
  },
  {
    value: '51',
    text: 'MT - Mato Grosso'
  },
  {
    value: '31',
    text: 'MG - Minas Gerais'
  },
  {
    value: '15',
    text: 'PA - Pará'
  },
  {
    value: '25',
    text: 'PB - Paraíba'
  },
  {
    value: '41',
    text: 'PR - Paraná'
  },
  {
    value: '26',
    text: 'PE - Pernambuco'
  },
  {
    value: '22',
    text: 'PI - Piauí'
  },
  {
    value: '33',
    text: 'RJ - Rio de Janeiro'
  },
  {
    value: '24',
    text: 'RN - Rio Grande do Norte'
  },
  {
    value: '43',
    text: 'RS - Rio Grande do Sul'
  },
  {
    value: '11',
    text: 'RO - Rondônia'
  },
  {
    value: '14',
    text: 'RR - Roraima'
  },
  {
    value: '42',
    text: 'SC - Santa Catarina'
  },
  {
    value: '35',
    text: 'SP - São Paulo'
  },
  {
    value: '28',
    text: 'SE - Sergipe'
  },
  {
    value: '17',
    text: 'TO - Tocantins'
  },
  {
    value: '98',
    text: 'EX - Países Estrangeiros'
  }
];

const organizacoes = [
  {
    value: '1',
    text: 'CRA - CONSELHO REGIONAL DE ADMINISTRAÇÃO'
  },
  {
    value: '2',
    text: 'CRE - CONSELHO REGIONAL DE ECONOMIA'
  },
  {
    value: '3',
    text: 'CREA - CONSELHO REG.DE ENG. ARQUIT. E AGRONOMIA'
  },
  {
    value: '4',
    text: 'CRF - CONSELHO REGIONAL DE FARMÁCIA'
  },
  {
    value: '5',
    text: 'DGPC - DIRETORIA GERAL DA POLÍCIA CIVIL'
  },
  {
    value: '6',
    text: 'DPF - DEPARTAMENTO DE POLÍCIA FEDERAL'
  },
  {
    value: '7',
    text: 'IDAMP - INSTITUTO IDENTIF. AROLDO MENDES PAIVA'
  },
  {
    value: '8',
    text: 'IFP - INSTITUTO FÉLIX PACHECO'
  },
  {
    value: '9',
    text: 'IN - IMPRENSA NACIONAL'
  },
  {
    value: '10',
    text: 'JUNTA - JUNTA'
  },
  {
    value: '11',
    text: 'MAER - MINISTÉRIO DA AERONÁUTICA'
  },
  {
    value: '12',
    text: 'MEX - MINISTÉRIO DO EXÉRCITO'
  },
  {
    value: '13',
    text: 'MM - MINISTÉRIO DA MARINHA'
  },
  {
    value: '14',
    text: 'OAB - ORDEM DOS ADVOGADOS DO BRASIL'
  },
  {
    value: '15',
    text: 'SEJSP - SECRETARIA DE EST. DA JUSTIÇA E SEG. PUB'
  },
  {
    value: '16',
    text: 'SES - SECRETARIA DE ESTADO DA SEGURANÇA'
  },
  {
    value: '17',
    text: 'SESP - SECRETARIA DO ESTADO SEG. PÚBLICA'
  },
  {
    value: '18',
    text: 'SJS - SECRETARIA DA JUSTIÇA E DA SEGURANÇA'
  },
  {
    value: '19',
    text: 'SJTC - SECR. DA JUST. DO TRAB. E DA CIDADANIA'
  },
  {
    value: '20',
    text: 'SSIPT - SECR.  DE SEG. E INFORM. POLÍCIA TÉCNICA'
  },
  {
    value: '21',
    text: 'SSP - SECRETARIA DE SEGURANÇA PÚBLICA'
  },
  {
    value: '22',
    text: 'VACIV - VARA CIVIL'
  },
  {
    value: '23',
    text: 'VAMEN - VARA DE MENORES'
  },
  {
    value: '24',
    text: 'PM - POLICIA MILITAR'
  },
  {
    value: '25',
    text: 'ITB - INSTITUTO TAVARES BURIL'
  },
  {
    value: '26',
    text: 'CRM - CONSELHO REGIONAL DE MEDICINA'
  },
  {
    value: '27',
    text: 'CBM - CORPO DE BOMBEIROS MILITAR'
  },
  {
    value: '28',
    text: 'DIC - DETRAN - DIRETORIA DE IDENTIFICAÇÃ CIVIL'
  },
  {
    value: '29',
    text: 'CFP - CONSELHO FEDERAL DE PSICOLOGIA'
  },
  {
    value: '30',
    text: 'CRO - CONSELHO REGIONAL DE ODONTOLOGIA'
  },
  {
    value: '31',
    text: 'COREN - CONSELHO REGIONAL DE ENFERMARIA'
  },
  {
    value: '32',
    text: 'CFN - CONSELHO FEDERAL DE NUTRICIONISTAS'
  },
  {
    value: '33',
    text: 'MRE - MINISTÉRIO DAS RELAÇÕES EXTERIORES'
  },
  {
    value: '34',
    text: 'CRCI - CONSELHO REG. DE CORRETORES DE IMÓVEIS'
  },
  {
    value: '35',
    text: 'CRB - CONSELHO REGIONAL DE BIOLOGIA'
  },
  {
    value: '36',
    text: 'CRN - CONSELHO REGIONAL DE NUTRIÇÃO'
  },
  {
    value: '37',
    text: 'CFE - CONSELHO FEDERAL DE ENFERMAGEM'
  },
  {
    value: '38',
    text: 'COREN - CONSELHO REGIONAL DE ENFERMARIA'
  },
  {
    value: '39',
    text: 'CRP - CONSELHO REGIONAL DE PSICOLOGIA'
  },
  {
    value: '40',
    text: 'CRQ - CONSELHO REGIONAL DE QUIMICA'
  },
  {
    value: '41',
    text: 'ANVISA - AGÊNCIA NACIONAL DE VIGILÂNCIA SANITÁRIA'
  },
  {
    value: '42',
    text: 'GOVEST - GOVERNO DO ESTADO'
  },
  {
    value: '43',
    text: 'PREF - PREFEITURA'
  },
  {
    value: '44',
    text: 'CRBM - CONSELHO REGIONAL DE BIOMEDICINA'
  },
  {
    value: '45',
    text: 'IPF - INSTITUTO PEREIRA FAUSTINO'
  },
  {
    value: '46',
    text: 'CREFITO - CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL'
  },
  {
    value: '47',
    text: 'CRMV - CONSELHO REGIONAL DE MEDICINA VETERINÁRIA'
  },
  {
    value: '48',
    text: 'MTE - MINISTÉRIO DO TRABALHO E EMPREGO'
  },
  {
    value: '49',
    text: 'CRFA - CONSELHO REGIONAL DE FONOAUDIOLOGIA'
  },
  {
    value: '50',
    text: 'CORECON - CONSELHO REGIONAL DE ECONOMIA'
  },
  {
    value: '51',
    text: 'SDS - SECRETARIA DE DESENVOLVIMENTO SOCIAL'
  },
  {
    value: '52',
    text: 'SRF - SECRETARIA DA RECEITA FEDERAL'
  },
  {
    value: '53',
    text: 'RMS - Registro Ministério da Saúde'
  }
];

export {
  conselhos,
  ufs,
  organizacoes
};
